import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { NavigationMenu } from './NavigationMenu';
import { Home } from 'lucide-react';

export default function DashWelcome() {
  const [username, setUsername] = useState('');
  const [trialMessage, setTrialMessage] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      const { data: { session }, error: sessionError } = await supabase.auth.getSession();
      if (sessionError) {
        console.error('Session fetch error:', sessionError);
        return;
      }

      if (session?.user?.id) {
        const userId = session.user.id;

        const { data: profile, error: profileError } = await supabase
          .from('profiles')
          .select('name, trial_ends_at, status')
          .eq('id', userId)
          .maybeSingle();

        if (profileError) {
          console.error('Profile fetch error:', profileError);
          return;
        }

        if (profile?.name) {
          const firstName = profile.name.split(' ')[0];
          setUsername(firstName);
        }

        if (profile?.trial_ends_at && profile.status === 'trialing') {
          const trialEnd = new Date(profile.trial_ends_at);
          const now = new Date();
          const diffTime = trialEnd.getTime() - now.getTime();
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          if (diffDays > 0) {
            setTrialMessage(`You have ${diffDays} day${diffDays !== 1 ? 's' : ''} left in your trial.`);
          } else {
            setTrialMessage('Your trial has ended.');
          }
        }
      }
    };

    fetchProfile();
  }, []);

  return (
    <div className="mb-6 flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-bold text-[#236caf] flex items-center gap-2">
          <Home className="w-5 h-5 text-[#236caf]" />
          Welcome, {username}!
        </h1>
        <p className="text-sm text-gray-600">Congrats On Elevating Your Life!</p>
        {trialMessage && (
          <p className="text-sm text-[#004060] mt-1">{trialMessage}</p>
        )}
      </div>
      <NavigationMenu />
    </div>
  );
}